import { createAction, props } from '@ngrx/store';
import { MobilityHub } from '../../../modules/mobility-hubs/interfaces';

// create mobility hub
export const CREATE_MOBILITY_HUB = '[Mobility Hubs] Create Mobility Hub';

export const CreateMobilityHub = createAction(CREATE_MOBILITY_HUB, props<{ payload: MobilityHub }>());

// edit mobility hub
export const EDIT_MOBILITY_HUB = '[Mobility Hubs] Edit Mobility Hub';

export const EditMobilityHub = createAction(EDIT_MOBILITY_HUB, props<{ payload: MobilityHub }>());

// delete mobility hub
export const DELETE_MOBILITY_HUB = '[Mobility Hubs] Delete Mobility Hub';

export const DeleteMobilityHub = createAction(DELETE_MOBILITY_HUB, props<{ payload: string }>());

// upload mobility hubs
export const UPLOAD_MOBILITY_HUBS = '[Mobility Hubs] Upload Mobility Hubs';

export const UploadMobilityHubs = createAction(UPLOAD_MOBILITY_HUBS, props<{ payload: MobilityHub[] }>());

// calculate moblity hubs supplies
export const CALCULATE_MOBILITY_HUBS_SUPPLIES = '[Mobility Hubs] Calculate Mobility Hubs Supplies';

export const CalculateMobilityHubsSupplies = createAction(CALCULATE_MOBILITY_HUBS_SUPPLIES, props<{ payload: any }>());

// action types
export type MobilityHubAction =
    | typeof CreateMobilityHub
    | typeof EditMobilityHub
    | typeof DeleteMobilityHub
    | typeof UploadMobilityHubs
    | typeof CalculateMobilityHubsSupplies;
